import { useEffect, useState, useMemo } from "react";

const SnowEffect = () => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    // Check if current date is before January 1, 2026
    const endDate = new Date("2026-01-01T00:00:00");
    const now = new Date();
    setIsActive(now < endDate);
  }, []);

  // Generate snowflakes with random properties
  const snowflakes = useMemo(() => {
    return Array.from({ length: 50 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      animationDuration: 8 + Math.random() * 12,
      animationDelay: Math.random() * 10,
      opacity: 0.3 + Math.random() * 0.5,
      size: 3 + Math.random() * 5,
    }));
  }, []);

  if (!isActive) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-[9999] overflow-hidden">
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="absolute rounded-full bg-white animate-snowfall"
          style={{
            left: `${flake.left}%`,
            width: `${flake.size}px`,
            height: `${flake.size}px`,
            opacity: flake.opacity,
            animationDuration: `${flake.animationDuration}s`,
            animationDelay: `${flake.animationDelay}s`,
            filter: "blur(0.5px)",
            boxShadow: "0 0 3px rgba(255, 255, 255, 0.8)",
          }}
        />
      ))}
    </div>
  );
};

export default SnowEffect;
